export default {
  STORE_MANAGER: 'STORE_MANAGER',
  STORE_ASSISTANT: 'STORE_ASSISTANT',
  CORPORATE: 'CORPORATE',
  CRM_MANAGER: 'CRM_MANAGER',
  LOCAL_EDITOR: 'LOCAL_EDITOR',
  RETAIL_MANAGER: 'RETAIL_MANAGER',
  AREA_MANAGER: 'AREA_MANAGER',
  TRAINING_MANAGER: 'TRAINING_MANAGER',
  OFFICE: 'OFFICE',
  FUR_SPECIALIST: 'FUR_SPECIALIST',
  ADMIN: 'ADMIN',
  TEST: 'TEST',
  FIELD_TRAINER: 'FIELD_TRAINER',
}
